import React from 'react';
import { Heading, HeadingType } from '../../../Typography';
import { WebinarSearch } from '../../Common/WebinarSearch';
import { WEBINAR_SEARCH_PROPS } from '../../Utils/types';

const WebinarHero = ({
  products,
  onProductChange,
  selectedProduct,
  onSearchChange,
  setSearchText,
  searchText,
  sticky,
  showProductDropdown,
}: WEBINAR_SEARCH_PROPS): JSX.Element => {
  return (
    <>
      {sticky ? (
        <div
          data-testid="webinar-hero-sticky"
          className="bg-clearsky-50 py-2 sticky w-full top-0 z-20"
        >
          <div className="wg-container">
            <WebinarSearch
              products={products}
              onProductChange={onProductChange}
              selectedProduct={selectedProduct}
              onSearchChange={onSearchChange}
              setSearchText={setSearchText}
              searchText={searchText}
              showProductDropdown={showProductDropdown}
            />
          </div>
        </div>
      ) : null}

      <div className="hero-gradient">
        <div data-testid="webinar-hero" className="hero-banner">
          <div className="wg-container py-20 sm:py-10">
            <Heading
              variant={HeadingType.h1}
              content="Webinars Built for Enterprise Decision-Makers"
              className="text-white text-center sm:text-s-34"
            />
            <p className="text-center text-white py-4 mb-8">
              Equip your finance, IT, and compliance teams with the clarity and
              confidence to navigate evolving business landscapes
            </p>

            <WebinarSearch
              products={products}
              onProductChange={onProductChange}
              selectedProduct={selectedProduct}
              onSearchChange={onSearchChange}
              setSearchText={setSearchText}
              searchText={searchText}
              showProductDropdown={showProductDropdown}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export { WebinarHero };
